import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  getInitalDateRangeForListData,
  isLargeScreen,
  isLargeScreenFun,
  updateCustomTableHeaders,
} from '../../../../global.variable';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { OrientationLockService } from '../../../shared/services/orientationlock.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { getDateTimeRange } from '../tableDetails';
import { CheckpointService } from './checkpoint.service';
import { AppService } from '../../../app.service';

@Component({
  selector: 'gtapp-checkpoints',
  templateUrl: './checkpoints.component.html',
  styleUrl: './checkpoints.component.scss',
  standalone: false,
})
export class CheckpointsComponent implements OnInit {
  largeView: Boolean = isLargeScreen;
  isAdmin = this.dataCheckService.isUserAdmin();
  isDispatchUser = this.dataCheckService.isDispatchUser();
  isLargeScreenSubscription: Subscription = new Subscription();

  checkpointSearchString: string = '';
  previousCheckpoints: number = 0;
  rowsCheckpoints: number = 10;
  pageNumCheckpoints: number = 1;
  totalPagesCheckpoints: number = 0;
  sortKeyCheckpoints: any;
  searchParamsCheckpoints: any;

  tableStyle = {
    'overflow': 'auto',
    'max-height': '75vh',
  };

  checkpointDropDownList: any = [];
  totalCheckpointCount: number = 0;

  checkpointPaginationData: any = {};
  otherParamsCheckpoints: any = {
    apiFiltering: true,
  };

  tabNames = {
    tab1: 'Checkpoints',
    tab2: 'QR Codes',
    tab3: 'Missed Scans',
  };

  checkPointDetailsTableView: any = this.largeView
    ? [
        {
          header: 'Checkpoint',
          sortKey: 'name',
          searchKey: 'name',
          imageObj: true,
          prefixNestedValue: (row: any) => {
            return row?.name;
          },
          nestedValue: (row: any) => {
            const isQRNFC = Boolean(row?.qr_code);
            if (!isQRNFC) return false;
            return row?.is_nfc_code
              ? 'assets/images/NFC_logo.avif'
              : 'assets/images/qr-code-logo.avif';
          },
          conditionalImageStyle: (row: any) => {
            return Boolean(row?.qr_code)
              ? {
                  'width': '32px',
                  'float': 'right',
                  'background': 'white',
                  'padding': '0.25rem',
                  'border-radius': '5px',
                  'margin-right': '2rem',
                }
              : {};
          },
        },
        {
          header: 'Site / Client',
          name: 'site_name',
          sortKey: 'site__company_name',
          searchKey: 'site__company_name',
          nestedValue: (row: any) => {
            return row?.site_name ? row.site_name : row?.company;
          },
          suffixNestedValue: (row: any) => {
            return row?.site_name ? `\n${row?.company}` : null;
          },
          suffixStyle: {
            'font-size': 'small',
          },
          tableColumnStyle: {
            'white-space': 'pre-line',
          },
        },
        {
          header: 'Location',
          name: 'partial_address',
          searchKey: 'partial_address',
        },
      ]
    : [
        {
          header: 'Checkpoint',
          sortKey: 'name',
          imageObj: true,
          prefixNestedValue: (row: any) => {
            return row?.name;
          },
          nestedValue: (row: any) => {
            const isQRNFC = Boolean(row?.qr_code);
            if (!isQRNFC) return false;
            return row?.is_nfc_code
              ? 'assets/images/NFC_logo.avif'
              : 'assets/images/qr-code-logo.avif';
          },
          conditionalImageStyle: (row: any) => {
            return Boolean(row?.qr_code)
              ? {
                  'width': '32px',
                  'float': 'right',
                  'background': 'white',
                  'padding': '0.25rem',
                  'border-radius': '5px',
                  'margin-right': '2rem',
                }
              : {};
          },
        },
        {
          header: 'Site / Client',
          sortKey: 'site__company_name',
          nestedValue: (row: any) => {
            return row?.site_name ? row.site_name : row?.company;
          },
          suffixNestedValue: (row: any) => {
            return row?.site_name
              ? `\n${row?.company}\n${row?.partial_address}`
              : null;
          },
          suffixStyle: {
            'font-size': 'small',
          },
          tableColumnStyle: {
            'white-space': 'pre-line',
          },
        },
      ];

  selectedCp: any;

  validateQR: boolean = false;

  qrToBeValidated: boolean = false;
  selectedTab: string = this.tabNames.tab1;
  checkPointCardsDetails: any = {
    individualDetails: [
      {
        imageObj: true,
        nestedValue: (row: any) => {
          const isQRNFC = Boolean(row?.qr_code);
          if (!isQRNFC) return false;
          return row?.is_nfc_code
            ? 'assets/images/NFC_logo.avif'
            : 'assets/images/qr-code-logo.avif';
        },
        imageStyle: {
          'width': '26px',
          'float': 'right',
          'background': 'white',
          'padding': '0.25rem',
          'border-radius': '5px',
        },
      },
      {
        name: 'name',
        cardRowStyle: { 'font-weight': 'bold' },
      },
      {
        nestedValue: (row: any) => {
          if (row?.site_name) {
            return `${row?.site_name} [${row?.company}]`;
          }
          return row?.company;
        },
        cardRowStyle: { 'font-size': 'small' },
      },
      {
        cardRowStyle: { 'font-size': 'small' },
        nestedValue: (row: any) => {
          return row?.address?.full_address;
        },
      },
    ],
  };

  infiniteMissedCheckpointDataList: any = [];

  //missed checkpoint data variables
  missedCheckpointDefaultTimeRange = getDateTimeRange();
  totalRowsMissedCheckpoint: number = 0;
  previousMissedCheckpoint: number = 0;
  pageSizeMissedCheckpoint: number = 10;
  pageNumMissedCheckpoint: number = 1;
  totalPagesMissedCheckpoint: number = 0;
  searchParamsMissedCheckpoint: any = {
    missed_at__range: [
      this.missedCheckpointDefaultTimeRange?.dateRange?.start,
      this.missedCheckpointDefaultTimeRange?.dateRange?.end,
    ],
  };
  sortKeysMissedCheckpoint: any = [];

  otherParamsMissedCheckpoint: any = {};
  missedCheckpointData: any;

  tableDetailMissedCheckpoint = [
    // Date and Time Range
    {
      header: 'Shift',
      name: 'missed_at',
      datetimeObj: true,
      dateTimeFormat: 'd MMM y',
      dateRangeKey: 'missed_at',
      sortKey: 'missed_at',
      permanent: true,
      ...this.missedCheckpointDefaultTimeRange,
      tableColumnStyle: {
        'white-space': 'pre-line',
        'font-size': 'small',
      },
      prefixNestedValue: (row: any) => {
        return `${row?.time_range} \n`;
      },
      prefixStyle: { 'font-size': '0.95rem' },
    },

    // Patrol Route and [Assigned Guard(s)]
    {
      header: 'Route',
      name: 'patrol_route_name',
      searchKey: 'patrol_route__name',
      sortKey: 'patrol_route__name',
      tableColumnStyle: {
        'white-space': 'pre-line',
      },
      suffixStyle: {
        'font-size': 'small',
      },
      suffixNestedValue: (row: any) => {
        return `\n ${row?.guards?.join(', ')}`;
      },
    },

    {
      header: 'Checkpoint',
      searchKey: 'check_point__name',
      sortKey: 'check_point__name',
      nestedValue: (row: any) => {
        let cpName = row?.checkpoint_name;
        if (['qr', 'nfc'].includes(row?.cp_type))
          cpName += `  [${row?.cp_type?.toUpperCase()}]`;

        return cpName;
      },
      tableColumnStyle: {
        'white-space': 'pre-line',
        'font-weight': '500',
      },
      suffixNestedValue: (row: any) => {
        return row?.site_name
          ? `\n ${row?.site_name} [${row?.company_name}]`
          : `\n ${row?.company_name}`;
      },
      suffixStyle: {
        'font-size': 'small',
        'font-weight': 'normal',
      },
    },
  ];

  mobileDetailMissedCheckpoint = {
    individualDetails: [
      {
        name: 'checkpoint_name',
        cardRowStyle: {
          'font-weight': 600,
        },
      },
      {
        name: 'site_name',
        cardRowStyle: { 'font-size': 'small' },
        suffixNestedValue: (row: any) => {
          return row?.site_name ? ` [${row?.company_name}]` : row?.company_name;
        },
      },

      {
        prefix: 'Route: ',
        name: 'patrol_route_name',
        suffixNestedValue: (row: any) => {
          return ' [' + row?.guards?.join(', ') + ']';
        },
      },

      {
        name: 'missed_at',
        dateTimeFormat: 'd MMM y',
        datetimeObj: true,
        dateRangeKey: 'missed_at',
        default: true,
        ...getDateTimeRange(),
        suffixNestedValue: (row: any) => {
          return `${row?.time_range}`;
        },
        suffixStyle: {
          'font-weight': '700',
          'font-size': '0.85rem',
        },
      },
    ],
  };
  urlFragmentDetails: any = {};

  screenWidth = window.innerWidth;
  splitScreenPx: number = 1300;
  constructor(
    private checkpointService: CheckpointService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: ModalDialogueService,
    private dataCheckService: DataCheckService,
    private toasterService: ToasterService,
    private orientationService: OrientationLockService,
    private appService: AppService,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }
  ngOnDestroy() {
    this.isLargeScreenSubscription?.unsubscribe();
  }
  getCheckpointCountStats() {
    this.checkpointService
      .listCheckpointData({ checkpoint_count_stats: 1 })
      .subscribe((response: any) => {
        this.qrToBeValidated = response?.validate_qr_codes;
      });
  }

  async ngOnInit() {
    const userData = this.appService.getUserData();
    this.rowsCheckpoints = Number(
      userData?.preferences?.checkpoint_page_size || this.rowsCheckpoints,
    );
    if (this.isAdmin) this.getCheckpointCountStats();

    this.isLargeScreenSubscription =
      this.orientationService.isLargeScreen.subscribe(async (event: any) => {
        if (event) {
          this.largeView = await isLargeScreenFun();
        }
      });

    this.changeTab(this.selectedTab);
  }

  getCheckpointsCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.otherParamsCheckpoints = {
            ...this.otherParamsCheckpoints,
            paginationData: {
              totalRows: response?.total_size,
              previousRows: this.previousCheckpoints,
              rows: this.rowsCheckpoints,
              pageNum: this.pageNumCheckpoints,
              totalPages: this.totalPagesCheckpoints,
            },
          };

          this.totalCheckpointCount = response?.cp_count;

          if (this.validateQR && !response?.total_size) {
            this.router.navigate(['/']);
            return;
          }
        }
      });
  }
  getCheckpointListData(getCount = true) {
    let params: any = {};
    if (this.rowsCheckpoints) {
      params['rows'] = this.rowsCheckpoints;
      let userData = this.appService.getUserData();
      if (userData?.preferences) {
        userData.preferences.checkpoint_page_size = this.rowsCheckpoints;
        this.appService.setUserData(userData);
      }
    }

    if (this.previousCheckpoints) {
      params['previous'] = this.previousCheckpoints;
    }
    if (this.checkpointSearchString) {
      params['search_str'] = this.checkpointSearchString;
    }

    if (this.searchParamsCheckpoints) {
      Object.entries(this.searchParamsCheckpoints).forEach(
        ([key, value]) => (params[key] = value),
      );
    }

    if (this.sortKeyCheckpoints) {
      params['sort_key'] = this.sortKeyCheckpoints;
    }
    if (this.validateQR) {
      params['is_invalid'] = 1;
    }
    const routeParams: any = this.route.snapshot.paramMap;

    if (routeParams) {
      if (routeParams.get('clientId'))
        params['company_id'] = routeParams.get('clientId');
      if (routeParams.get('siteId'))
        params['site_id'] = routeParams.get('siteId');
    }

    if (this.checkpointPaginationData?.[this.pageNumCheckpoints]?.length)
      return;
    if (getCount) this.getCheckpointsCount(params);

    this.spinnerService.show();
    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.checkpointPaginationData[this.pageNumCheckpoints] = [
            ...response?.data,
          ];
          this.updateRoutPath();

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationCheckpoint(data: any) {
    this.previousCheckpoints = data?.paginationData?.previousRows;
    this.pageNumCheckpoints = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsCheckpoints) {
      this.checkpointPaginationData = {};
    }
    this.rowsCheckpoints = data?.paginationData?.rows;

    this.otherParamsCheckpoints.paginationData = {
      ...data?.paginationData,
    };
    this.getCheckpointListData(false);
  }
  sortColumnCheckpoint(body: any) {
    this.sortKeyCheckpoints = body?.sortList || [];
    this.searchParamsCheckpoints = body?.searchParams || {};
    this.checkpointSearchString = '';
    this.checkpointPaginationData = {};
    this.getCheckpointListData(false);
  }
  searchColumnCheckpoint(event: any) {
    this.searchParamsCheckpoints = event?.searchParams || {};
    if (event === 'updateRouteOnly') {
      this.updateRoutPath();
    } else {
      this.clearValues();
      this.getCheckpointListData();
    }
  }
  clearValues() {
    this.previousCheckpoints = 0;
    this.pageNumCheckpoints = 1;
    this.checkpointSearchString = '';
    this.checkpointPaginationData = {};
  }

  onCheckpointLookup(event: any) {
    if (event.target.value.length > 3) {
      let params: any = { search_str: event.target.value };

      this.checkpointService
        .listCheckpointData(params)
        .subscribe((res: any) => {
          if (res['status'] == 'success') {
            this.checkpointDropDownList = res?.data;
          }
        });
    }
  }

  addCheckpoints() {
    this.router.navigate(['/add-checkpoint'], { relativeTo: this.route });
  }
  deleteCheckPoint(event: any) {
    let dialogMsg = `WARNING: This action cannot be reversed.`;
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete Checkpoint ${event?.name}`,
        message: dialogMsg,
        alertDanger: true,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        this.checkpointService
          .deleteCheckpointById(event.id)
          .then((response: any) => {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
            let subscriberStats = JSON.parse(
              localStorage.getItem('subscriberStats') || '{}',
            );
            subscriberStats.checkpoint_count =
              (subscriberStats?.checkpoint_count || 0) - 1;
            localStorage.setItem(
              'subscriberStats',
              JSON.stringify(subscriberStats),
            );
            this.selectedCp = undefined;
            this.clearValues();
            this.getCheckpointListData();
          });
      }
    });
  }

  redirectCompanyORSite(cp: any) {
    if (cp?.site_id) {
      this.router.navigate(['/view-site', { sKey: String(cp?.site_id) }]);
    } else {
      this.router.navigate(['/view-client', { cKey: String(cp?.company_id) }]);
    }
  }
  onCheckpointRedirect(event: any) {
    this.router.navigate(['/view-checkpoints', { cpKey: String(event?.id) }]);
  }

  onCheckPointClick(event: any) {
    if (this.validateQR || this.screenWidth < this.splitScreenPx) {
      this.onCheckpointRedirect(event);
    } else {
      if (event?.id === this.selectedCp?.id) {
        this.onCheckpointRedirect(event);
      }
      this.selectedCp = event;
    }
  }

  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsCheckpoints,
          otherParams: this.otherParamsCheckpoints,
          checkpointSearchString: this.checkpointSearchString,
          selectedTab: this.selectedTab,
          searchParamsMissedCheckpoint: this.searchParamsMissedCheckpoint,
          validateQR: this.validateQR,
        }),
      ),
      queryParams: {},
      replaceUrl: true, // Replaces the current URL without adding a new history entry
    });
  }

  changeTab(event: any) {
    if (!Object.values(this.tabNames)?.includes(event)) {
      event = this.tabNames.tab1;
    }
    this.selectedTab = event;
    switch (this.selectedTab) {
      case this.tabNames.tab1:
        this.getCheckpointListData();
        break;
      case this.tabNames.tab2:
        this.updateRoutPath();
        break;

      case this.tabNames.tab3:
        this.resetPageMissedCheckPoint();
        this.getMissedCheckpointData();
    }
  }

  validateCheckpoints() {
    this.validateQR = !this.validateQR;
    this.clearValues();
    this.selectedCp = null;
    this.getCheckpointListData();
  }

  getMissedCheckpointData() {
    let body: any = {};
    this.spinnerService.show();

    if (this.sortKeysMissedCheckpoint)
      body.sort_key = this.sortKeysMissedCheckpoint;
    if (this.searchParamsMissedCheckpoint)
      body.search_filters = this.searchParamsMissedCheckpoint;

    if (this.pageSizeMissedCheckpoint) {
      body['rows'] = this.pageSizeMissedCheckpoint;
    }
    if (this.previousMissedCheckpoint) {
      body['previous'] = this.previousMissedCheckpoint;
    }

    this.checkpointService
      .missedCheckpoints(body)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.totalRowsMissedCheckpoint = response['total_size'];

          this.totalPagesMissedCheckpoint = Math.ceil(
            this.totalRowsMissedCheckpoint / this.pageSizeMissedCheckpoint,
          );
          this.otherParamsMissedCheckpoint = {
            apiFiltering: true,
            paginationData: {
              totalRows: this.totalRowsMissedCheckpoint,
              previousRows: this.previousMissedCheckpoint,
              rows: this.pageSizeMissedCheckpoint,
              pageNum: this.pageNumMissedCheckpoint,
              totalPages: this.totalPagesMissedCheckpoint,
            },
          };
          this.missedCheckpointData = response['data'];
          let newList = response?.data;
          this.infiniteMissedCheckpointDataList =
            this.infiniteMissedCheckpointDataList.concat(newList);
          this.updateRoutPath();
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  redirectToPatrol(event: any) {
    if (event?.patrol_route_id) {
      this.router.navigate([
        '/view-route',
        { rKey: String(event.patrol_route_id) },
      ]);
    }
  }

  onChangePaginationMissedCheckpoint(data: any) {
    this.previousMissedCheckpoint = data?.paginationData?.previousRows;
    this.pageNumMissedCheckpoint = data?.paginationData?.pageNum;
    this.pageSizeMissedCheckpoint = data?.paginationData?.rows;

    this.getMissedCheckpointData();

    this.otherParamsMissedCheckpoint.paginationData = {
      ...data?.paginationData,
    };
  }
  sortColumnMissedCheckpoint(sortData: any) {
    this.resetPageMissedCheckPoint();
    this.sortKeysMissedCheckpoint = sortData?.sortList || [];
    this.getMissedCheckpointData();
  }
  searchColumnMissedCheckpoint(event: any) {
    this.searchParamsMissedCheckpoint = event?.searchParams || {};

    if (event === 'updateRouteOnly') {
      this.updateRoutPath();
    } else {
      this.resetPageMissedCheckPoint();
      this.getMissedCheckpointData();
    }
  }
  resetPageMissedCheckPoint() {
    this.infiniteMissedCheckpointDataList = [];
    this.totalRowsMissedCheckpoint = 0;
    this.previousMissedCheckpoint = 0;
    this.pageSizeMissedCheckpoint = 10;
    this.pageNumMissedCheckpoint = 1;
    this.totalPagesMissedCheckpoint = 0;
    this.otherParamsMissedCheckpoint.paginationData = {
      totalRows: this.totalRowsMissedCheckpoint,
      previousRows: this.previousMissedCheckpoint,
      rows: this.pageSizeMissedCheckpoint,
      pageNum: this.pageNumMissedCheckpoint,
      totalPages: this.totalPagesMissedCheckpoint,
    };
  }

  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsCheckpoints = {
          ...this.searchParamsCheckpoints,
          ...(urlFragmentDetails?.searchParams || {}),
        };
        this.searchParamsMissedCheckpoint = {
          ...this.searchParamsMissedCheckpoint,
          ...(urlFragmentDetails?.searchParamsMissedCheckpoint || {}),
        };
        this.selectedTab =
          urlFragmentDetails?.selectedTab || this.tabNames.tab1;

        if (!Object.values(this.tabNames)?.includes(this.selectedTab)) {
          this.selectedTab = this.tabNames.tab1;
        }
        this.validateQR = urlFragmentDetails?.validateQR || false;

        this.checkpointSearchString =
          urlFragmentDetails?.checkpointSearchString || '';

        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousCheckpoints =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousCheckpoints;
          this.pageNumCheckpoints =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumCheckpoints;
          this.rowsCheckpoints =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsCheckpoints;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    if (this.selectedTab === this.tabNames.tab1) {
      updateCustomTableHeaders(
        this.checkPointDetailsTableView,
        this.searchParamsCheckpoints,
      );
      this.checkPointDetailsTableView = [...this.checkPointDetailsTableView];
    }
    if (this.selectedTab === this.tabNames.tab3) {
      updateCustomTableHeaders(
        this.tableDetailMissedCheckpoint,
        this.searchParamsMissedCheckpoint,
      );

      this.tableDetailMissedCheckpoint = [...this.tableDetailMissedCheckpoint];
    }
  }
}
